

















































































































































































































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import * as _ from "lodash";
import Button from "@/shared/components/ui/Button.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  PartnerUser,
  UserRole,
  PartnerUserRequest,
  UserPermission,
  Permission,
  RoleType,
  FetchState,
  MfaItem,
  OktaFactorType,
  oktaFactorTypeMap,
  UserRoleNames,
} from "@/shared/types";
import PartnerUserAdd from "@/shared/components/partners/PartnerUserAdd.vue";
import PartnerNotificationEmailForm from "@/shared/components/partners/PartnerNotificationEmailForm.vue";
import { Validator } from "vee-validate";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { usePartnerUserStore } from "@/shared/store/partnerUser";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useThemeStore } from "@/shared/store/theme";
import PartnerUserEditModal from "./PartnerUserEditModal.vue";
import { useRoleStore } from "@/shared/store/role";

const UnknownErrorMessage = "Error processing your request. Please try again later";
const initialSearchTerms = {
  firstName: "",
  lastName: "",
  searchEmail: "",
  userRole: UserRole.None
};

@Component({
  components: {
    Button,
    GenericLoadingSpinner,
    Pagination,
    PartnerUserAdd,
    PartnerNotificationEmailForm,
    PartnerUserEditModal
  }
})
export default class PartnerUsers extends Vue {
  $validator: Validator;
  $UserRole = UserRole;
  OktaFactorTypeMap = oktaFactorTypeMap;

  userStore = useUserStore();
  notifierStore = useNotifierStore();
  partnerUserStore = usePartnerUserStore();
  rolePermissionsStore = useRolePermissionsStore();
  roleStore = useRoleStore();
  featureFlagStore = useFeatureFlagStore();
  themeStore = useThemeStore();

  isSubmitting = false;
  selectedPartnerUser = {};
  searchTerm = { ...initialSearchTerms };
  tableFields = [
    {
      key: "userInfo",
      label: "Name"
    },
    {
      key: "roles",
      label: "Roles and Permissions"
    },
    {
      key: "status",
      label: "Sign-up Status"
    }
  ];
  showConfirmDisableMfaModal = false;
  showManageMfaModal = false;
  selectedPartnerUserEmail = "";
  partnerRoles = [];
  factorsLoading = false;
  enrolledFactors: MfaItem[] = [];
  factorsToRemove: OktaFactorType[] = [];
  mfaResetInProgress = false;

  site = process.env.VUE_APP_PORTAL;

  @Prop() partnerId: number;

  @Prop() userPageNumber: number;

  mounted (): void {
    this.searchTerm = {...initialSearchTerms };
    this.partnerUserStore.setPageNumber(this.userPageNumber);
    const request: PartnerUserRequest = {
      partnerId: this.partnerId,
      pageNumber: this.userPageNumber,
      searchFirstname: this.searchTerm.firstName,
      searchLastname: this.searchTerm.lastName,
      searchEmail: this.searchTerm.searchEmail,
      searchRole: this.searchTerm.userRole
    };
    this.partnerUserStore.loadPartnerUsers(request);
    this.roleStore.getPartnerRoles();
  }

  handleError (err) {
    this.notifierStore.setDanger(err.errorMessage || UnknownErrorMessage);
  }

  onPageChanged (pageNumber: number): void {
    this.$router.push(`/partner/${this.partnerId}/users/${pageNumber}`);
  }

  get userRoleOptions () {
    return this.roleStore.partnerRoles.map(role => ({text: role.displayName ? role.displayName : role.roleName, value: role.roleId}));
  }

  get manageMfaLabel () {
    return this.featureFlagStore.flags.bend23884EmpPortalOktaLogin ? "Manage MFA" : "Disable MFA";
  }

  get resetMfaDisabled () {
    return this.factorsToRemove.length < 1 || this.mfaResetInProgress;
  }

  @Watch("userPageNumber")
  onRouteValuePageNumberChanged () {
    this.partnerUserStore.setPageNumber(this.userPageNumber);
    const request: PartnerUserRequest = {
      partnerId: this.partnerId,
      pageNumber: this.userPageNumber,
      searchFirstname: this.searchTerm.firstName,
      searchLastname: this.searchTerm.lastName,
      searchEmail: this.searchTerm.searchEmail,
      searchRole: this.searchTerm.userRole
    };
    this.partnerUserStore.loadPartnerUsers(request);
  }

  @Watch("partnerId")
  onPartnerIdChange () {
    this.partnerUserStore.setPageNumber(1);
    const request: PartnerUserRequest = {
      partnerId: this.partnerId,
      pageNumber: 1,
      searchFirstname: this.searchTerm.firstName,
      searchLastname: this.searchTerm.lastName,
      searchEmail: this.searchTerm.searchEmail,
      searchRole: this.searchTerm.userRole
    };
    this.partnerUserStore.loadPartnerUsers(request);
  }

  sendActivationLink (inviteId: number) {
    this.partnerUserStore.resendPartnerUserSignupLink(inviteId);
  }

  handleRoleUpdateError (message: string, partnerUser: PartnerUser) {
    delete this.rolesChanging[partnerUser.inviteId];
    this.notifierStore.setDanger(message);
    this.partnerUserStore.updatePartnerUser(partnerUser);
  }

  rolesChanging = [];
  onRoleClicked (partnerUser: PartnerUser, event) {
    const roleId = Number(event.target.value);
    const securityPermissionRoleId = this.roleStore.partnerRoles.find(r => r.roleName === UserRoleNames.partnerSecurity).roleId;
    if (roleId === securityPermissionRoleId) {
      const roleIncluded = partnerUser.userRoles.includes(roleId);
      if (roleIncluded) {
        if (this.partnerUserStore.numberOfOwners <= 1) {
          this.notifierStore.setDanger("At least one user must have the Security role");
          return event.preventDefault();
        } else {
          this.partnerUserStore.adjustNumberOfOwners(-1);
        }
      } else {
        this.partnerUserStore.adjustNumberOfOwners(1);
      }
    }
    this.rolesChanging[partnerUser.inviteId] = partnerUser;
  }

  debouncedRoleChange = [];
  handleRoleChange (partnerUser) {
    this.partnerUserStore.updatePartnerUser(partnerUser);

    if (!this.debouncedRoleChange[partnerUser.inviteId]) {
      this.debouncedRoleChange[partnerUser.inviteId] = _.debounce(partnerUser => this.onRoleChange(partnerUser), 1000);
    }
    this.debouncedRoleChange[partnerUser.inviteId](partnerUser);
  }

  onPartnerUserEditClick (partnerUser: PartnerUser): void {
    this.selectedPartnerUser = _.cloneDeep(partnerUser) ;
    this.$root.$emit("bv::toggle::modal", "partner-user-edit-modal", "#modal-toggle");
  }

  onPartnerUserEditModalClose (): void {
    this.$root.$emit("bv::toggle::modal", "partner-user-edit-modal", "#modal-toggle");
  }

  onPartnerUserEditModalSave (editedPartnerUser: PartnerUser): void {
    this.partnerUserStore.updatePartnerUserData(this.partnerId, editedPartnerUser)
    .then((userSave: any) => {
        if (userSave.error) {
          this.notifierStore.setDanger("Could not update partner user");
        } else {
          this.notifierStore.setSuccess("Partner user data updated");
        }
      }).catch(err => {
        this.notifierStore.setDanger("Could not update partner user");
      });

    this.$root.$emit("bv::toggle::modal", "partner-user-edit-modal", "#modal-toggle");
  }


  onRoleChange (partnerUser): void {
    delete this.debouncedRoleChange[partnerUser.inviteId];
    this.partnerUserStore.partnerUserSave({
        partnerId: this.partnerId,
        partnerUser
      }).then((userSave: any) => {
        if (userSave.error) {
          this.handleRoleUpdateError(userSave.error, this.rolesChanging[partnerUser.inviteId]);
        } else {
          this.notifierStore.setSuccess("Partner user roles saved");
        }
      }).catch(err => {
        this.handleRoleUpdateError("Could not save user roles", this.rolesChanging[partnerUser.inviteId]);
      });
  }
  get isFormValid () {
      return !this.$validator.errors.any();
  }

  get isSearchDisabled () {
      return this.isSubmitting === true || !this.isFormValid;
  }

  get isClearDisabled () {
      return this.isSubmitting === true;
  }

  onSearch (): void {
    if (this.isSubmitting) return;
    this.$validator
      .validate()
      .then(result => {
        if (!result) return;
        this.isSubmitting = true;
        if (this.userPageNumber > 1) {
          return this.onPageChanged(1);
        }
        const request: PartnerUserRequest = {
          partnerId: this.partnerId,
          pageNumber: 1,
          searchFirstname: this.searchTerm.firstName,
          searchLastname: this.searchTerm.lastName,
          searchEmail: this.searchTerm.searchEmail,
          searchRole: this.searchTerm.userRole
        };
        this.partnerUserStore.loadPartnerUsers(request);
      }).finally(() => this.isSubmitting = false);
    }
  clearSearch (): void {
    if (!this.isSubmitting) {
      this.searchTerm = { ...initialSearchTerms };
      if (this.userPageNumber > 1) {
          return this.onPageChanged(1);
      }
      this.isSubmitting = true;
      const request: PartnerUserRequest = {
          partnerId: this.partnerId,
          pageNumber: 1,
          searchFirstname: this.searchTerm.firstName,
          searchLastname: this.searchTerm.lastName,
          searchEmail: this.searchTerm.searchEmail,
          searchRole: this.searchTerm.userRole
        };
      this.partnerUserStore.loadPartnerUsers(request);
      this.isSubmitting = false;
    }
  }

  resetPassword (email: string) {
    this.partnerUserStore.sendForgotPasswordLink({ partnerId: this.partnerId, email });
  }

  showConfirmDisableMfa (email: string) {
    if (this.featureFlagStore.flags.bend23884EmpPortalOktaLogin) {
      this.onShowManageMfaModal(email);
    } else {
      this.showConfirmDisableMfaModal = true;
    }

    this.selectedPartnerUserEmail = email;
  }

  onShowManageMfaModal (email: string) {
    this.factorsLoading = true;
    this.showManageMfaModal = true;

    this.partnerUserStore.loadMfaOptions({ partnerId: this.partnerId, email })
      .then(data => {
        this.enrolledFactors = data.mfaOptions;
      })
      .catch(() => {/* noop */})
      .finally(() => {
        this.factorsLoading = false;
      });
  }

  closeDisableMfaModal () {
    this.showConfirmDisableMfaModal = false;
    this.selectedPartnerUserEmail = "";
  }

  closeManageMfaModal () {
    this.showManageMfaModal = false;
    this.factorsLoading = false;
    this.selectedPartnerUserEmail = "";
    this.enrolledFactors = [];
    this.factorsToRemove = [];
    this.mfaResetInProgress = false;
  }

  mfaSelectionUpdated (mfaType: OktaFactorType) {
    const index = this.factorsToRemove.indexOf(mfaType);
    if (index > -1) {
      this.factorsToRemove.splice(index, 1);
    } else {
      this.factorsToRemove.push(mfaType);
    }
  }

  resetMfa () {
    if (this.factorsToRemove.length < 1 || this.mfaResetInProgress) {
      return;
    }

    this.mfaResetInProgress = true;

    this.partnerUserStore.resetMfaOptions({
        partnerId: this.partnerId,
        email: this.selectedPartnerUserEmail,
        mfaOptions: this.factorsToRemove
      })
      .then(() => {
        this.closeManageMfaModal();
      })
      .catch(() => {/* noop */})
      .finally(() => {
        this.mfaResetInProgress = false;
      });
  }

  confirmDisableMfa (email) {
    this.partnerUserStore.sendDisableMfaLink({ partnerId: this.partnerId, email });
    this.closeDisableMfaModal();
  }

  get hasEditPermission (): boolean {
    switch (this.site) {
      case "admin": return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
      case "employer": return this.rolePermissionsStore.userHasPartnerPermission(Permission.ManagePartnerUserWrite, this.partnerId);
      default: return false;
    }
  }

  get hasViewPermission (): boolean {
    switch (this.site) {
      case "admin": return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit) ||
          this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerView);
      case "employer": return this.rolePermissionsStore.userHasPartnerPermission(Permission.ManagePartnerUserRead, this.partnerId);
      default: return false;
    }
  }
}
